import React from 'react';
import { FlexyTabs } from '@europrocurement/flexy-components';
import { FormaliteDocument } from '@europrocurement/l2d-domain';
import DocumentTypeMainTab from './DocumentTypeMainTab';
import DocumentTypeFormalitiesTab from './DocumentTypeFormalitiesTab';

type DocumentTypeShowLayoutProps = {
    documentType: FormaliteDocument;
};

const DocumentTypeShowLayout: React.FunctionComponent<DocumentTypeShowLayoutProps> = function (
    props,
) {
    const { documentType } = props;

    return (
        <FlexyTabs
            scrollbar={false}
            tabs={[
                {
                    tabName: 'main',
                    tabPanel: <DocumentTypeMainTab documentType={documentType} />,
                    tabTitle: 'Informations générales',
                },
                {
                    tabName: 'formalities',
                    tabPanel: (
                        <DocumentTypeFormalitiesTab documentTypeId={documentType.id as number} />
                    ),
                    tabTitle: 'Formalités rattachées',
                },
            ]}
            routerParameterName="documentTypeTab"
        />
    );
};

export default DocumentTypeShowLayout;
